import Vue from 'vue'
import App from './App.vue'
import './plugins/request.js'
import './plugins/element.js'
import router from './router'
import './assets/css/fonts/iconfont.css'
import store from './store'
import { Message } from 'element-ui'
import has from './assets/js/permission'
import global_variable from "@/components/global_variable";
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

// 环境变量调试信息
console.log('=== 环境变量调试信息 ===');
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('VUE_APP_API_BASE_URL:', process.env.VUE_APP_API_BASE_URL);
console.log('VUE_APP_PREVIEW_BASE_URL:', process.env.VUE_APP_PREVIEW_BASE_URL);
console.log('VUE_APP_PORT:', process.env.VUE_APP_PORT);
console.log('VUE_APP_DEBUG:', process.env.VUE_APP_DEBUG);
console.log('=== 调试信息结束 ===');

Vue.prototype.global = global_variable
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/'
axios.interceptors.request.use(config => {
  config.headers.Token = window.sessionStorage.getItem('token')
  return config
})

// 状态码错误信息
const codeMessage = {
  401: '用户没有权限，请登录',
  403: '用户没有权限，请联系管理员',
  404: '访问的资源不存在',
  406: '请求的格式不可得',
  410: '请求的资源被永久删除，且不会再得到的',
  422: '当创建一个对象时，发生一个验证错误',
  500: '服务器发生错误，请检查服务器',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时'
};

// 防重复弹窗标志
let isShowingAuthError = false;

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error) {
    if (!error.response) {
      return console.log('Error', error.message);
    }
    //获取状态码
    const status = error.response.status;

    // 401 错误特殊处理
    if (status === 401) {
      // 清除本地存储
      window.sessionStorage.clear();

      // 防止重复弹窗
      if (isShowingAuthError) {
        return Promise.reject(error);
      }
      isShowingAuthError = true;

      // 从后端响应中获取具体的错误消息
      const errorMsg = error.response.data?.message || '登录状态已过期，请重新登录';

      // 使用 Element UI 的 MessageBox 显示具体错误提示
      import('element-ui').then(({ MessageBox }) => {
        MessageBox.alert(
          errorMsg,
          '登录提示',
          {
            confirmButtonText: '去登录',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false,
            callback: () => {
              isShowingAuthError = false;
              router.push('/login');
            }
          }
        );
      });
      return Promise.reject(error);
    }

    const errortext = codeMessage[status] || error.response.statusText;
    //提示错误信息
    Message.error(errortext)

    // 错误状态处理
    if (status === 403) {
      router.push('/login')
    } else if (status >= 404 && status < 422) {
      router.push('/404')
    }
  }
  return Promise.reject(error)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
